export default __webpack_public_path__ + "static/media/content.531a7d7b.svg";